<script>
import {
  Chart as ChartJS,
  DoughnutController,
  ArcElement,
  Tooltip,
} from "chart.js";
import ChartJSBase from "./chart_js_base.vue";

ChartJS.register(Tooltip);
ChartJS.register(ArcElement);
ChartJS.register(DoughnutController);

export default {
  name: "ChartJSDoughnut",

  extends: ChartJSBase,

  data() {
    return {
      type: "doughnut",
    };
  },
};
</script>
